import $script from 'scriptjs';
import Product from '../components/Product';
import ProductItem from '../components/ProductItem';

export default class StaticProduct {
  constructor(section) {
    this.el = section.el;
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    const $scripts = $('[data-scripts]');

    $script($scripts.data('shopify-api-url'), () => {
      this.product = new Product({ el: this.el, data: section.data });

      for (let i = 0; i < this.productEls.length; i++) {
        this.products.push(new ProductItem(this.productEls[i]));
      }
    });

  }

  onSectionUnload() {
    this.product.unload();
    this.products.forEach(product => product.unload());
    this.rtes.forEach(rte => rte.unload());
  }
}
